import {apiUrl, get} from '../utilities/SimpleClient';
import {cacheUser, readAccessToken, readCachedUser, storeAccessToken} from './authentication';

const resolveCurrentUserHelper = async () => {
    const cachedUser = readCachedUser();
    if (cachedUser) {
        return cachedUser;
    }

    const freshUser = await get('whoami');
    cacheUser(freshUser);

    return freshUser;
};

export const authenticate = async (username, password) => {
    const clientId = process.env.REACT_APP_PLATO_LEGACY_CLIENT_ID;
    const clientSecret = process.env.REACT_APP_PLATO_LEGACY_CLIENT_SECRET;

    const data = new URLSearchParams();
    data.append('client_id', clientId);
    data.append('client_secret', clientSecret);

    if (username && password) {
        data.append('grant_type', 'password');
        data.append('username', username);
        data.append('password', password);
    } else if (localStorage.refresh_token && localStorage.refresh_token !== '') {
        data.append('grant_type', 'refresh_token');
        data.append('refresh_token', localStorage.refresh_token);
    }

    const accessToken = await readAccessToken();
    const response = await fetch(apiUrl('/oauth/v2/token'), {
        method: 'POST',
        headers: new Headers({
            'Content-Type': 'application/x-www-form-urlencoded',
            'Authorization': `Bearer ${ accessToken }`,
        }),
        body: data,
    });

    if (response.status === 200) {
        try {
            const {
                access_token,
                refresh_token,
            } = await response.json();

            storeAccessToken(access_token, refresh_token);

            return await resolveCurrentUserHelper();
        } catch (error) {
            console.error(error);
        }
    }

    return undefined;
};
